import { Config } from '.';

const config: Config = {
  env: 'production',
  apiServerBase: `https://poker-api-prod.sharath.app`,
  useMockData: false,
};

export default config;
